import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-service-agreement',
  templateUrl: './service-agreement.component.html',
  styleUrl: './service-agreement.component.scss',
  standalone: false
})
export class ServiceAgreementComponent {
  @Input() CompanyName: string = '';
  @Input() isHighlighted: boolean = false;
}
